import {
    GET_ITEMS,
    GET_ITEM,
    ADD_ITEM,
    DELETE_ITEM,
    UPDATE_ITEM,
    SET_CURRENT,
    CLEAR_CURRENT,
    ITEM_ERROR,
} from '../types'

const itemReducer = (state, action) => {
    switch (action.type) {
        case GET_ITEMS:
            return {
                ...state,
                items: action.payload,
            }
        case GET_ITEM:
            return {
                ...state,
                currentItem: action.payload,
            }
        case SET_CURRENT:
            return {
                ...state,
                currentItem: action.payload,
            }
        case CLEAR_CURRENT:
            return {
                ...state,
                currentItem: null,
            }
        case ADD_ITEM:
            return {
                ...state,
                items: [...state.items, action.payload],
            }
        case DELETE_ITEM:
            return {
                ...state,
                items: state.items.filter(
                    (item) => item._id !== action.payload._id
                ),
            }
        case UPDATE_ITEM:
            return {
                ...state,
                items: state.items.map((item) =>
                    item._id === action.payload._id ? action.payload : item
                ),
            }
        case ITEM_ERROR:
            return {
                ...state,
                error: action.payload,
            }
        default:
            return state
    }
}

export default itemReducer